import React from "react";
// import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import './styles.css';

const Capacidade = () => {
  return (
    <>
      <Card className="text-center">
        <Card.Header><div className="opcoes">Capacidade</div></Card.Header>
        <Card.Body>
          <Card.Title><div className="opcoes">Limite de dispositivos conectados</div></Card.Title>
          <Card.Text>
          <div className="opcoes">
            Roteadores de baixo custo geralmente não suportam um grande número de dispositivos conectados simultaneamente
          </div>
          <div className="opcoes">
          A quantidade de dispositivos que um roteador pode suportar varia significativamente de 
          acordo com o modelo e a marca. Modelos básicos podem suportar entre 10 a 20, roteadores de alto desempenho, como 
          aqueles que suportam Wi-Fi 6 e Wi-Fi 6E, podem gerenciar 50 ou mais dispositivos com eficiência.
          </div>
          </Card.Text>
          {/* <Button variant="primary">Go somewhere</Button> */}
        </Card.Body>
        <Card.Footer className="text-muted">
        <div className="opcoes">O custo para a aquisição de equipamentos que suportem alta carga de trabalho 
        pode variar amplamente dependendo da marca e modelo. </div>
        </Card.Footer>
      </Card>
    </>
  )
}
export default Capacidade;